import React from 'react';
import { Loading } from '@components';

const FullScreenLoading = ({ isLoading }) =>
  isLoading && (
    <div className="loading-wrapper-fullscreen">
      <Loading tip="loading..." />
    </div>
  );

export default FullScreenLoading;
